import request from '@/utils/request';
import { ResCode, CommonResponse, PagingResData, PagingReq, Company } from './baseDefine';
/**
 * 请求公司共用的请求结构
 *
 * @export
 * @interface CompanyCommonReq
 * @extends {PagingReq}
 */
export interface CompanyCommonReq extends PagingReq {
    company: Company;
}
export interface GetCompany {
    code: ResCode;
    msg: string;
    data: GetCompanyRes;
}

export interface TzsRes {
    code: ResCode;
    msg: string;
    data: Tzs;
}

export interface Tzs {
    tzs: string[];
}
export interface GetCompanyRes {
    companys: GetCompanyResData;
}
export interface GetCompanyResData extends PagingResData {
    list: Company[];
}
export function createCompany(req: CompanyCommonReq): Promise<CommonResponse> {
    return request.post<CommonResponse>('/api/company/createCompany', req);
}
export function tzs(): Promise<TzsRes> {
    return request.post<TzsRes>('/api/company/tzs', {});
}

export function deleteCompany(req: CompanyCommonReq): Promise<CommonResponse> {
    return request.post<CommonResponse>('/api/company/deleteCompany', req);
}

export function updateCompany(req: CompanyCommonReq): Promise<CommonResponse> {
    return request.post<CommonResponse>('/api/company/updateCompany', req);
}

export function geCompanys(req: CompanyCommonReq): Promise<GetCompany> {
    return request.post<GetCompany>('/api/company/getCompanys', req);
}
